import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import buoyIcon from '../../../../../../assets/pictures/buoy.png';

import css from './MenuIcon.module.css';

const MenuIcon = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <img src={buoyIcon} alt='buoy' className={classes} />
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  rootClassName: null,
  className: null,
};

MenuIcon.propTypes = {
  rootClassName: string,
  className: string,
};

export default MenuIcon;
